"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var useStyles = function useStyles() {
  var ccTaskManagerEditTaskGuidelinesStyle = (0, _react.useMemo)(function () {
    var ccTaskManagerEditTaskGuidelines = (0, _css.css)({
      display: 'flex',
      flexDirection: 'column',
      height: '100%'
    });
    return {
      ccTaskManagerEditTaskGuidelines: ccTaskManagerEditTaskGuidelines
    };
  }, []);
  return {
    'cc-TaskManager__edit-task-guidelines': ccTaskManagerEditTaskGuidelinesStyle.ccTaskManagerEditTaskGuidelines
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;